import PropTypes from "prop-types";
import React, { useState } from "react";
import { Container, Card, CardBody, Row, Col } from "reactstrap";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import ClientMenu from "./detail-menu";

const ClientInbox = props => {
  document.title = "Admin | Client Inbox";

  // ================= CONVERSATIONS =================
  const conversations = [
    {
      id: 1,
      clientName: "John Smith",
      subject: "Dashboard access issue",
      lastMessage: "Please update, this is urgent.",
      lastTime: "09:30 AM",
      unread: true,
      messages: [
        {
          id: 1,
          senderType: "client",
          senderName: "John Smith",
          message: "I am unable to access my dashboard.",
          date: "2025-01-05",
          time: "10:15 AM",
        },
        {
          id: 2,
          senderType: "support",
          senderName: "Support Agent A",
          message: "We are checking this issue.",
          date: "2025-01-05",
          time: "11:00 AM",
        },
        {
          id: 3,
          senderType: "client",
          senderName: "John Smith",
          message: "Please update, this is urgent.",
          date: "2025-01-06",
          time: "09:30 AM",
        },
      ],
    },
    {
      id: 2,
      clientName: "Sarah Lee",
      subject: "Invoice not downloading",
      lastMessage: "Thanks, it works now.",
      lastTime: "12:15 PM",
      unread: false,
      messages: [
        {
          id: 1,
          senderType: "client",
          senderName: "Sarah Lee",
          message: "Invoice download is not working.",
          date: "2025-01-10",
          time: "02:00 PM",
        },
        {
          id: 2,
          senderType: "support",
          senderName: "Support Agent B",
          message: "Fix deployed. Please try again.",
          date: "2025-01-12",
          time: "11:30 AM",
        },
        {
          id: 3,
          senderType: "client",
          senderName: "Sarah Lee",
          message: "Thanks, it works now.",
          date: "2025-01-12",
          time: "12:15 PM",
        },
      ],
    },
  ];

  const [selectedConversation, setSelectedConversation] = useState(
    conversations[0]
  );

  // ================= MESSAGE TIMELINE =================
  const MessageTimeline = ({ messages }) => (
    <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
      {messages.map(msg => (
        <div
          key={msg.id}
          className={`d-flex mb-3 ${
            msg.senderType === "client"
              ? "justify-content-start"
              : "justify-content-end"
          }`}
        >
          <div
            className={`p-3 rounded shadow-sm ${
              msg.senderType === "client"
                ? "bg-light border"
                : "bg-primary text-white"
            }`}
            style={{ maxWidth: "70%" }}
          >
            <div className="fw-bold mb-1">{msg.senderName}</div>
            <div className="mb-2">{msg.message}</div>
            <div className="small text-muted text-end">
              {msg.date} • {msg.time}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  // ================= UI =================
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Breadcrumbs
            title={props.t("Clients")}
            breadcrumbItem={props.t("Inbox")}
          />

          <ClientMenu />

          <Row>
            {/* ================= INBOX ================= */}
            <Col md="4">
              <Card>
                <CardBody>
                  <h5 className="mb-3">Inbox</h5>

                  {conversations.map(conv => (
                    <div
                      key={conv.id}
                      onClick={() => setSelectedConversation(conv)}
                      className={`p-3 border-bottom cursor-pointer ${
                        selectedConversation.id === conv.id
                          ? "bg-light"
                          : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex justify-content-between">
                        <strong>{conv.clientName}</strong>
                        <span className="text-muted small">
                          {conv.lastTime}
                        </span>
                      </div>

                      <div className="text-muted small">
                        {conv.subject}
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <span className="small text-truncate">
                          {conv.lastMessage}
                        </span>
                        {conv.unread && (
                          <span className="badge bg-primary ms-2">
                            New
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </CardBody>
              </Card>
            </Col>

            {/* ================= MESSAGE PANEL ================= */}
            <Col md="8">
              <Card>
                <CardBody>
                  {selectedConversation ? (
                    <>
                      <h5 className="mb-3">
                        {selectedConversation.clientName}
                      </h5>

                      <MessageTimeline
                        messages={selectedConversation.messages}
                      />

                      {/* Reply box (UI only) */}
                      <div className="border-top pt-3 mt-3">
                        <textarea
                          className="form-control mb-2"
                          rows="2"
                          placeholder="Type your message..."
                        />
                        <div className="text-end">
                          <button className="btn btn-primary btn-sm">
                            Send
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-muted text-center">
                      Select a conversation
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

ClientInbox.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ClientInbox);
